/**
 * Self-hosted Inter via @fontsource (CSP-safe: no fonts.googleapis.com).
 * Weights match the previous Google Fonts webfontloader config.
 */
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/900.css'

export default function () {
  // Font CSS is loaded via the imports above; plugin hook is a no-op.
}
